module.exports = __webpack_public_path__ + "img/bni.54ba9907.png";